import { HotelGroupAccountings } from "../../../../HotelGroups/Accounting"
import { IHotelGroup } from "../../../../HotelGroups"
import { useOutletContext } from "../../../../router-utils"
import { Helmet } from "react-helmet-async"

export default function HotelGroupAccountingsPage() {
	const { group } = useOutletContext<{ group: IHotelGroup }>()
	return (
		<>
			<Helmet>
				<title>Accounting | Hotel Group</title>
			</Helmet>
			<HotelGroupAccountings group={group} />
		</>
	)
}
